module.exports = __webpack_public_path__ + "img/icon_5_45.d0d06c32.png";